<usu-procuracao-reurb-averbacao-v3 *ngIf="isProcuracao; else contratoTemplate" [cadastro]="cadastro"
  [proprietario]="proprietario" [conjuge]="conjuge" [imovel]="imovel" [tipo]="tipo">
</usu-procuracao-reurb-averbacao-v3>

<ng-template #contratoTemplate>
  <usucampeao-contrato-cdhu *ngIf="cadastro.projetoCategoria === projetoCategoria.CDHU; else projetoPadraoTemplate"
    [cadastro]="cadastro" [proprietario]="proprietario" [conjuge]="conjuge" [imovel]="imovel" [isPrint]="isPrint">
  </usucampeao-contrato-cdhu>

  <ng-template #projetoPadraoTemplate>

    <usucampeao-somente-averbacao-v3 *ngIf="cadastro.projetoTipo === tipoProjeto.AVERBACAO; else reurbTemplate"
      [cadastro]="cadastro" [proprietario]="proprietario" [conjuge]="conjuge" [imovel]="imovel"
      [isPrint]="isPrint"></usucampeao-somente-averbacao-v3>

    <ng-template #reurbTemplate>
      <usucampeao-reurb-averbacao-v3 *ngIf="cadastro.projetoTipo === tipoProjeto.REURB_TRADICIONAL"
        [cadastro]="cadastro" [proprietario]="proprietario" [conjuge]="conjuge" [imovel]="imovel"
        [isPrint]="isPrint"></usucampeao-reurb-averbacao-v3>
    </ng-template>
  </ng-template>
</ng-template>